import React from 'react';
import styles from './WeekHeader.module.scss';

const WeekHeader = () => {
  const currentDate = new Date();
  const dateStartOfWeek = new Date(
    currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1)
  );
  const dateEndOfWeek = new Date(
    currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 7)
  );
  const weekNumber =
    Math.ceil(
      (dateStartOfWeek.getTime() -
        new Date(dateStartOfWeek.getFullYear(), 0, 1).getTime()) /
        (1000 * 60 * 60 * 24 * 7)
    ) + 1;

  return (
    <div className={styles.container }>
      <div className={styles.dateContainer}>
        <span className={styles.weekNumber}>{`Semaine ${weekNumber}`}</span>
        <span className={styles.startDate}>{`Du ${new Intl.DateTimeFormat(
          'fr'
        ).format(dateStartOfWeek)}`}</span>
        <span className={styles.endDate}>{`Au ${new Intl.DateTimeFormat(
          'fr'
        ).format(dateEndOfWeek)}`}</span>
      </div>
    </div>
  );
};

export default WeekHeader;
